import { useLoanOfferFormContext } from '@sec-loans-ui/loan-offer/steps/formContext'
import { FormStep } from '@sec-loans-ui/loan-offer/steps/FormStep'
import { useWizardForm } from '@ui-common/hooks'
import { useIntl } from 'react-intl'

export const StatusStep = () => {
  const intl = useIntl()
  const { formatMessage } = intl
  const { proceed, loanOffer } = useLoanOfferFormContext()

  const methods = useWizardForm({
    defaultValues: loanOffer,
  })

  return (
    <FormStep
      allowBack={false}
      subHeader={formatMessage({ id: 'loan-offer-status-step-heading' })}
      formMethods={methods}
      onSubmit={proceed}
    />
  )
}
